import React, { useState } from 'react';
import { Shield } from 'lucide-react';
import { WA_URL } from './Shared';
import { LegalModal, LegalDoc } from './LegalModal';
export function Footer() {
  const [legalDoc, setLegalDoc] = useState<LegalDoc>(null);
  const year = new Date().getFullYear();
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-57">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <div className="grid md:grid-cols-2 gap-8 mb-8 pb-8 border-b border-slate-800" data-id="element-59">
          <div data-id="element-60">
            <div className="flex items-center gap-2 text-white font-bold text-xl mb-4" data-id="element-61">
              <Shield className="w-6 h-6" data-id="element-62" />
              Solución a Pensión
            </div>
            <p className="text-slate-400 max-w-sm" data-id="element-63">
              Asesoría Pensional Independiente para Colombianos
            </p>
          </div>

          <div className="md:text-right space-y-2" data-id="element-64">
            <p data-id="element-65">
              <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-66">
                📲 WhatsApp: 3125895366
              </a>
            </p>
            <p data-id="element-67">
              <a href="mailto:hola@solucionapension.com" className="hover:text-white transition-colors" data-id="element-68">
                📧 hola@solucionapension.com
              </a>
            </p>
            <p data-id="element-69">
              <a href="https://www.solucionapension.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-70">
                🌐 www.solucionapension.com
              </a>
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8" data-id="element-71">
          <p className="text-sm text-slate-500" data-id="element-72">
            © {year} Solución a Pensión. Todos los derechos reservados.
          </p>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm" data-id="element-73">
            <button onClick={() => setLegalDoc('terminos')} className="text-slate-400 hover:text-white transition-colors focus:outline-none focus:text-white" data-id="element-74">
              Términos y Condiciones
            </button>
            <button onClick={() => setLegalDoc('privacidad')} className="text-slate-400 hover:text-white transition-colors focus:outline-none focus:text-white" data-id="element-75">
              Política de Privacidad
            </button>
          </nav>
        </div>

        <div className="text-xs text-slate-500 leading-relaxed" data-id="element-76">
          <p data-id="element-77">
            Cumplimos con la Ley 1581 de 2012 — Protección de Datos Personales
            Colombia. Servicio de asesoría e información. No somos un fondo de
            pensiones ni entidad financiera vigilada por la Superfinanciera.
          </p>
        </div>
      </div>

      <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} data-id="element-78" />
    </footer>;
}